module.exports = __webpack_public_path__ + "media/teacher/components/GetStarted/images/PT G3-a353bb6f65726bafe49710bc662b65e0.gif";